import { render, staticRenderFns } from "./examChartInPage.vue?vue&type=template&id=60ba280e&scoped=true&"
import script from "./examChartInPage.vue?vue&type=script&lang=js&"
export * from "./examChartInPage.vue?vue&type=script&lang=js&"
import style0 from "./examChartInPage.vue?vue&type=style&index=0&id=60ba280e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba280e",
  null
  
)

export default component.exports